"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringFilters_1 = require("./StringFilters");
var empty = "";
exports.empty = empty;
var isSane = function (text) {
    return text !== undefined && text !== null;
};
var startsWith = function (text, match) {
    return isSane(text) && isSane(match) && match.length <= text.length ? text.indexOf(match) === 0 : false;
};
exports.startsWith = startsWith;
var endsWith = function (text, match) {
    if (isSane(text) && isSane(match) && match.length <= text.length) {
        var idx = text.lastIndexOf(match);
        return idx >= 0 && (idx + match.length === text.length);
    }
    return false;
};
exports.endsWith = endsWith;
var contains = function (text, match) {
    return isSane(text) && isSane(match) ? text.indexOf(match) >= 0 : false;
};
exports.contains = contains;
var each = function (text, cb) {
    if (text) {
        var tl = text.length;
        for (var i = 0; i < tl; i++) {
            cb(text.charAt(i), i, text);
        }
    }
};
exports.each = each;
exports.forEach = each;
var eachRtl = function (text, cb) {
    if (text) {
        var tl = text.length;
        for (var i = tl - 1; i >= 0; i--) {
            cb(text.charAt(i), i, text);
        }
    }
};
exports.eachRtl = eachRtl;
exports.forEachRtl = eachRtl;
exports.eachReverse = eachRtl;
exports.forEachReverse = eachRtl;
var some = function (text, pr) {
    if (text) {
        var tl = text.length;
        for (var i = 0; i < tl; i++) {
            if (pr(text.charAt(i), i, text)) {
                return true;
            }
        }
    }
    return false;
};
exports.some = some;
var someRtl = function (text, pr) {
    if (text) {
        var tl = text.length;
        for (var i = tl - 1; i >= 0; i--) {
            if (pr(text.charAt(i), i, text)) {
                return true;
            }
        }
    }
    return false;
};
exports.someRtl = someRtl;
exports.someReverse = someRtl;
var every = function (text, pr) {
    if (text) {
        var tl = text.length;
        for (var i = 0; i < tl; i++) {
            if (!pr(text.charAt(i), i, text)) {
                return false;
            }
        }
    }
    return true;
};
exports.every = every;
var everyRtl = function (text, pr) {
    if (text) {
        var tl = text.length;
        for (var i = tl - 1; i >= 0; i--) {
            if (!pr(text.charAt(i), i, text)) {
                return false;
            }
        }
    }
    return true;
};
exports.everyRtl = everyRtl;
exports.everyReverse = everyRtl;
var filter = function (text, pr) {
    if (text) {
        var r_1 = empty;
        var action = function (ch, idx, source) {
            if (pr(ch, idx, source)) {
                r_1 += ch;
            }
        };
        each(text, action);
        return r_1;
    }
    return text;
};
exports.filter = filter;
var reject = function (text, pr) {
    if (text) {
        var r = empty;
        var action = function (ch, idx, source) {
            if (!pr(ch, idx, source)) {
                r += ch;
            }
        };
        each(text, action);
        return r;
    }
    return text;
};
exports.reject = reject;
var map = function (text, m) {
    if (text) {
        var r_2 = empty;
        var mc_1;
        var action = function (ch, idx, source) {
            mc_1 = m(ch, idx, source);
            if (mc_1) {
                r_2 += mc_1;
            }
        };
        each(text, action);
        return r_2;
    }
    return text;
};
exports.map = map;
var split = function (text, pr) {
    var r = [];
    if (text) {
        var b_1 = empty;
        var action = function (ch, idx, source) {
            if (pr(ch, idx, source)) {
                if (b_1) {
                    r.push(b_1);
                    b_1 = empty;
                }
            }
            else {
                b_1 += ch;
            }
        };
        each(text, action);
        if (b_1) {
            r.push(b_1);
        }
    }
    return r;
};
exports.split = split;
var removeWhitespace = function (text) {
    return reject(text, StringFilters_1.isWhitespace);
};
exports.removeWhitespace = removeWhitespace;
var findIndexOf = function (text, pr) {
    var foundIdx = -1;
    if (pr) {
        var spr = function (ch, idx, source) {
            if (pr(ch, idx, source)) {
                foundIdx = idx;
                return true;
            }
            return false;
        };
        some(text, spr);
    }
    return foundIdx;
};
exports.findIndexOf = findIndexOf;
var findLastIndexOf = function (text, pr) {
    var foundIdx = -1;
    if (pr) {
        var spr = function (ch, idx, source) {
            if (pr(ch, idx, source)) {
                foundIdx = idx;
                return true;
            }
            return false;
        };
        someRtl(text, spr);
    }
    return foundIdx;
};
exports.findLastIndexOf = findLastIndexOf;
var leftTrim = function (text) {
    var idx = findIndexOf(text, StringFilters_1.isNotWhitespace);
    return idx > 0 ? text.substring(idx) : text;
};
exports.leftTrim = leftTrim;
exports.trimLeft = leftTrim;
var rightTrim = function (text) {
    var idx = findLastIndexOf(text, StringFilters_1.isNotWhitespace);
    return idx > 0 ? text.substring(0, idx + 1) : text;
};
exports.rightTrim = rightTrim;
exports.trimRight = rightTrim;
var trim = function (text) {
    return rightTrim(leftTrim(text));
};
exports.trim = trim;
var isBlank = function (text) {
    return every(text, StringFilters_1.isWhitespace);
};
exports.isBlank = isBlank;
var isNotBlank = function (text) {
    return !isBlank(text);
};
exports.isNotBlank = isNotBlank;
var startsWithIgnoreCase = function (text, match) {
    return isSane(text) && isSane(match) ? startsWith(text.toLowerCase(), match.toLowerCase()) : false;
};
exports.startsWithIgnoreCase = startsWithIgnoreCase;
var endsWithIgnoreCase = function (text, match) {
    return isSane(text) && isSane(match) ? endsWith(text.toLowerCase(), match.toLowerCase()) : false;
};
exports.endsWithIgnoreCase = endsWithIgnoreCase;
var containsIgnoreCase = function (text, match) {
    return isSane(text) && isSane(match) ? contains(text.toLowerCase(), match.toLowerCase()) : false;
};
exports.containsIgnoreCase = containsIgnoreCase;
var equalsIgnoreCase = function (l, r) {
    return (l === r) || (l !== undefined && r !== undefined ? l.toLowerCase() === r.toLowerCase() : false);
};
exports.equalsIgnoreCase = equalsIgnoreCase;
var padLeft = function (s, length, padChar) {
    if (padChar === void 0) { padChar = " "; }
    var r = s || "";
    while (r.length < length) {
        r = padChar + r;
    }
    return r;
};
exports.padLeft = padLeft;
exports.leftPad = padLeft;
var stripLeft = function (s, stripChar) {
    if (s) {
        var idx = findIndexOf(s, function (ch) {
            return ch !== stripChar;
        });
        if (idx > 0) {
            return s.substring(idx);
        }
    }
    return s;
};
exports.stripLeft = stripLeft;
exports.leftStrip = stripLeft;
var padRight = function (s, length, padChar) {
    if (padChar === void 0) { padChar = " "; }
    var r = s || "";
    while (r.length < length) {
        r = r + padChar;
    }
    return r;
};
exports.padRight = padRight;
exports.rightPad = padRight;
var stripRight = function (s, stripChar) {
    if (s) {
        var idx = findLastIndexOf(s, function (ch) {
            return ch !== stripChar;
        });
        if (idx < s.length - 1) {
            return s.substring(0, idx + 1);
        }
    }
    return s;
};
exports.stripRight = stripRight;
exports.rightStrip = stripRight;
var join = function (items, textMap, separator) {
    var elems = [];
    if (items && items.length > 0) {
        var it_1;
        items.forEach(function (item, idx) {
            it_1 = textMap(item, idx);
            if (isNotBlank(it_1)) {
                elems.push(it_1);
            }
        });
    }
    return elems.length > 0 ? elems.join(separator) : "";
};
exports.join = join;
var capitalizeFirstLetter = function (value) {
    return isSane(value) && value.length > 0 ? value.charAt(0).toUpperCase() + value.slice(1) : value;
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var wordsToCamelCase = function (text) {
    if (text) {
        var items = split(text, StringFilters_1.isWhitespace).filter(function (w) { return isNotBlank(w); });
        if (items.length > 0) {
            items = items.map(function (item, idx) {
                return idx > 0 ? capitalizeFirstLetter(item) : item.toLowerCase();
            });
            return items.join("");
        }
    }
    return text;
};
exports.wordsToCamelCase = wordsToCamelCase;
